<script lang="ts" context="module">
    import { i18n, pfadstore } from "../store"
    import { get, writable } from "svelte/store"

    export const activeNav = writable<NavElement>(null)

    export function getNavPfad(seite: Seite): NavElement[] {
        let n = get(pfadstore)[seite.pfad]
        const nP = []
        while (n) {
            nP.unshift(n)
            n = n.parent
        }
        return nP
    }

    export function getBreadcrumb(seite: Seite): string {
        const navPfad = getNavPfad(seite)
        if (navPfad?.length) {
            let o = ""
            for (let i = 0; i < navPfad.length; i++) {
                const n = navPfad[i]
                if (i) {
                    o += " // "
                }
                o += n.name
            }
            return o
        }

        const $i18n = get(i18n)
        let o = ""
        console.log(seite)
        if (seite.typ?.includes("news")) {
            o += $i18n("Presse") + " // "
        } else if (seite.typ?.includes("position")) {
            o += $i18n("Positionen") + " // "
        } else if (seite.typ?.includes("standpunkt")) {
            o += $i18n("Unternehmer-Standpunkte") + " // "
        } else if (seite.typ?.includes("veranstaltung")) {
            o += $i18n("Veranstaltungen") + " // "
        }
        o += seite.titel
        console.log(o)
        return o
    }
</script>

<script lang="ts">
    export let seite: Seite

    $: $activeNav = $pfadstore[seite.pfad]

    $: breadcrumb = getBreadcrumb(seite)
</script>

<div id="breadcrumb">
    {breadcrumb}
</div>

<style lang="less" global>
    @import "../css/base.less";
    #breadcrumb {
        color: #878787;
        font-size: 0.9rem;
        margin-bottom: 30px;
    }
</style>
